import { Component } from '@angular/core';
import { LoginService } from '../../services/login/login.service';
import { Router } from '@angular/router';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { environment } from '../../../environments/environment';
import { PractitionerService } from '../../services/practitioner/practitioner.service';

@Component({
    standalone: false,
    selector: 'cva-side-nav-user-menu-items',
    templateUrl: './side-nav-user-menu-items.component.html',
    styleUrl: './side-nav-user-menu-items.component.scss',
    
})
export class SideNavUserMenuItemsComponent {
  cvaUI_url = environment.cvaUI_url;

  constructor(private readonly router: Router, private readonly loginService: LoginService, public practitionerService: PractitionerService) { }

  logout() {
    console.log("Logging out");
    this.loginService.logout();
    this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
  }

  changePassword() {
    console.log("Change password clicked");
    this.router.navigate([ROUTE_CONSTANTS.CHANGE_PASSWORD]);
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }

}
